import 'css-chunksrc/client/pages/projectPage/documentsPage/reportsPage/filterForm/styles.scss';export default {
  "filters": "_filters_1mdew_1",
  "resetButton": "_resetButton_1mdew_9",
  "label": "_label_1mdew_17",
  "section": "_section_1mdew_23"
};